import { render } from "./expired-products-modal.vue?vue&type=template&id=bc2b82b8"
import script from "./expired-products-modal.vue?vue&type=script&lang=js"
export * from "./expired-products-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__